/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { showTost } from "../../showTost";
import Loading from "../../Loading";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

const EventCategory = () => {

    const { t } = useTranslation();

    const { BaseUrl, setIsLoginShow } = useContext(MyContext);

    const [eventData, setEventData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navoigate = useNavigate();
    const Location = useLocation();
    const Data = Location.state;

    useEffect(() => {
        window.scrollTo(0, 0);
        HandleFechData();
    }, [Data]);

    const HandleFechData = () => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${BaseUrl}user_api/u_cat_event.php`, { uid: Userid, cat_id: Data?.EventId })
                .then((res) => {
                    // console.log("u_cat_event", res);
                    setEventData(res.data.CatEventData);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("u_cat_event", error);
                });
        }
    };

    const handleNavigate = (item) => {
        navoigate("/event-details");
        sessionStorage.setItem("Eventid", item);
    };

    const handleFavorite = (e, eventId) => {
        e.stopPropagation();

        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_fav.php`,
                {
                    uid: Userid,
                    eid: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    // console.log(res);
                    if (res?.data?.ResponseCode === '200') {
                        HandleFechData();
                    }
                    const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
                    showTost(res?.data?.ResponseMsg, toastType);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        } else {
            setIsLoginShow(true);
        }
    };

    return (
        <div className="width_container">
            <div className="event_category">

                <div className="section_1">
                    <div className="box bg-white flex flex-col justify-center p-[30px]">
                        <h1 className="font-bold text-[40px]">{Data.Title}</h1>
                        <div className="flex items-center gap-[10px]">
                            <Link to="/" className="font-bold text-gray-500">{t("Home")}</Link>
                            <MdOutlineKeyboardArrowRight />
                            <h1 className="font-bold text-gray-400">{Data.Title}</h1>
                        </div>
                    </div>
                    <div className="box">
                        <img src={BaseUrl + Data.CoverImg} className="w-[100%] h-[100%] object-cover" alt="" />
                    </div>
                </div>

                <div className="section_2">
                    <div className="flex flex-wrap items-center gap-[10px]">
                        {eventData.length >= 1
                            ? eventData.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(item.event_id)} className="card_box">
                                    <div className="img_box">
                                        <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover" alt="" />
                                    </div>
                                    <div className="detail_box">
                                        <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                                            <div className="trim">
                                                <span>{item.event_title}</span>
                                                <p>{item.event_place_name}</p>
                                            </div>
                                            <div className="price_btn">{item.ticket_price}</div>
                                        </div>
                                        <p style={{ borderTop: "1px solid", paddingTop: "10px", fontSize: "14px" }}>{item.event_sdate}</p>
                                    </div>
                                    <div style={{ justifyContent: "space-between" }} className="detail_box flex_box">
                                        <div className="flex_box">
                                            <img src={BaseUrl + item.event_sponsore_img} alt="" />
                                            <span className="font-bold">{item.event_sponsore_title}</span>
                                        </div>
                                        <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                            {item.IS_BOOKMARK === 0
                                                ? <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                    <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                </svg>
                                                : <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                    <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                </svg>
                                            }
                                        </div>
                                    </div>
                                </div>
                            })
                            : <div className="w-[100%] h-[200px] flex items-center justify-center">
                                <h1 className="font-bold text-[20px] text-gray-600">{t("Event Not Available !!")}</h1>
                            </div>}
                    </div>
                </div>

            </div>

            {loading && <Loading />}

        </div>
    )
}

export default EventCategory
/* jshint ignore:end */